import { svgBasePath } from '../../../../play-core/utils/base-path';
import { toSeoString } from '../../../../play-core/utils/to-seo-string';

// Try to use rawImageUrl or imageUrl whenever possible, instead to use this local hosted images
export const TvLogo = title => `${svgBasePath}/tv/${toSeoString(title)}.svg?cb=${import.meta.env.VITE_COMMIT_SHA}`;